import React from "react";

/**
 * Tiny affiliate disclosure shown beneath any commerce CTA on the site.
 *
 *   • variant="booking" (default) — Book Now / Book your stay pills on
 *     Dream, Bookmarks, Explore grid, Explore swipe deck. Redirects to
 *     a third-party booking provider.
 *   • variant="amazon" — Buy on Amazon pills inside every Backpack
 *     surface (per-trip Backpack, chapter story view, admin Backpack
 *     Lists panel). Required by Amazon's Associates Operating Agreement
 *     — full policy language lives on `/policies/affiliate-disclosure`.
 *
 * Keep wording consistent and copy-edited in ONE place — change here to
 * update everywhere.
 */
const COPY = {
  booking:
    "TravelBio may receive a commission from booking through this link",
  amazon:
    "TravelBio is an Amazon Associate and may earn a commission from qualifying purchases at no extra cost to you",
};

export default function AffiliateDisclosure({ variant = "booking", className = "" }) {
  const text = COPY[variant] || COPY.booking;
  return (
    <p
      data-testid={`affiliate-disclosure-${variant}`}
      data-variant={variant}
      className={
        "font-hand text-tb-navy/45 italic text-[10px] leading-snug text-center mt-1.5 " +
        className
      }
    >
      {text}
    </p>
  );
}
